import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { faArrowUp, faChevronUp, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ItemRss } from 'app/shared/models/itemRss/itemRss';
import { Menu } from 'app/shared/models/Menus/menus';
import { DataService } from 'app/shared/services/data/data.service';
import { SearchFilterService } from 'app/shared/services/search-filter/search-filter.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';


@Component({
  selector: 'app-actu',
  templateUrl: './actu.component.html',
  styleUrls: ['./actu.component.scss']
})
export class ActuComponent extends SubscriptionBaseComponent implements OnInit {

  faSearch = faSearch;
  faArrowUp = faArrowUp;
  faTimes = faTimes;
  faChevronUp = faChevronUp;

  menu: Menu;

  searchForm: FormGroup;
  valueInput: string;

  itemsFlux: ItemRss[] = [];
  itemsFluxFilter = [];

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private filterService: SearchFilterService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private titleService: TitleService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.titleService.title.next('Toutes mes actus');
    this.initForm();
    this.initSub();
    this.getSingleMenu();
  }

  scrollToElement(): void {
    document.querySelector('#target').scrollIntoView({ behavior: 'smooth' });
    // document.getElementById('flux_actu').style.paddingTop = '100px';
    // $element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  applyFilter(filterValue: string): void {
    this.valueInput = filterValue;
    this.itemsFluxFilter = [];
    this.filterFlux(filterValue);
    this.resetFlux(this.itemsFlux);
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.applyFilter('');
  }

  private getSingleMenu() {
    this.userService.getMenuUser().subscribe(res => {
      res.forEach(item => {
        if (item.lien === 'actus') {
          this.menu = item;
        }
      });
      this.getFluxRss();
    });
  }

  private getFluxRss(): void {
    this.userService.allMyActus(this.menu?.addPersona, this.menu?.addFonction).subscribe(res => {
      this.itemsFlux = res;
    });
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private get f(): object {
    return this.searchForm.controls;
  }

  private resetFlux(flux: any): void {
    this.itemsFlux = flux;
  }

  private filterFlux(filterValue: string): void {
    this.itemsFluxFilter = this.filterService.filter(this.itemsFlux, filterValue);
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.keyword.asObservable().subscribe(kw => {
          this.searchForm.get('keyword').setValue(kw);
          this.applyFilter(kw);
          this.cdr.detectChanges();
        })
      );
  }

}
